// removed by extract-text-webpack-plugin
module.exports = {"stopScrolling":"FavNotifications-style__stopScrolling__ea774000","spinnerContainer":"FavNotifications-style__spinnerContainer__ea774000","favSpinnerWrapper":"FavNotifications-style__favSpinnerWrapper__ea774000","listContainer":"FavNotifications-style__listContainer__ea774000","tileList":"FavNotifications-style__tileList__ea774000"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FavNotifications/FavNotifications-style.scss
// module id = ./src/components/FavNotifications/FavNotifications-style.scss
// module chunks = 4